<template>
  <div class="review-list-page">
    <el-button class="breadcrumb-export-btn" style="width: 120px; height: 50px; background: #000; color: #fff; border-color: #000" @click="handleExport">下载</el-button>
    <div class="white-container full-page-container common-table">
      <el-table v-loading="loading" :data="list">
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="name" label="申请人姓名" />
        <el-table-column prop="status" label="状态">
          <template slot-scope="{ row }">
            <span v-if="row.status === 0" class="status-tag status-pending">待审核</span>
            <span v-else-if="row.status === 1" class="status-tag status-passed">已通过</span>
            <span v-else-if="row.status === 2" class="status-tag status-rejected">拒绝</span>
          </template>
        </el-table-column>
        <el-table-column prop="identity" label="当前身份" />
        <el-table-column prop="region" label="所在地区" />
        <el-table-column prop="contact" label="联系方式" />
        <el-table-column prop="createTime" label="提交时间">
          <template slot-scope="{ row }">{{ formatTime(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" style="color: #0085D0" @click="handleView(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { clubApplyList, exportEnrollmentList } from "@/api/rugby";

export default {
  name: "RugbyReview",
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      size: 10,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatTime(time) {
      if (!time) return "";
      const d = new Date(time);
      const pad = n => String(n).padStart(2, "0");
      return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())}-${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    async getList() {
      this.loading = true;
      try {
        const res = await clubApplyList({ current: this.page, limit: this.size });
        this.list = res.data;
        this.total = res.total;
      } finally {
        this.loading = false;
      }
    },
    handleView({ id }) {
      this.$router.push({
        path: "/rugby/review/edit",
        query: { id },
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleExport() {
      exportEnrollmentList()
        .then(res => {
          if (!res) {
            this.$message.error("暂无数据");
          } else {
            this.$message.success("下载成功");
          }
        });
    },
  },
};
</script>

<style scoped>
.status-tag {
  display: inline-block;
  width: 100px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
}
.status-pending {
  color: #EA9921;
  background: #EA99211A;
  border: 1px solid #EA9921B2;
}
.status-passed {
  color: #60AC56;
  background: #60AC561A;
  border: 1px solid #60AC56B2;
}
.status-rejected {
  color: #DC0019;
  background: #DC00191A;
  border: 1px solid #DC0019B2;
}
.pagination >>> .el-pager li.active {
  color: #fff;
}
.review-list-page {
  position: relative;
}
.breadcrumb-export-btn {
  position: absolute;
  top: -66px;
  right: 20px;
  z-index: 10;
}
</style>
